module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container-fluid"
  }, [_c('h1', [_vm._v("rmCloud Configuration")]), _vm._v(" "), _c('requirement-types-view'), _vm._v(" "), _c('custom-attributes-view'), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('h4', [_vm._v("Link Confluence Content")]), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('p', [_vm._v("You have successfully connected your confluence instance.")]) : _c('p', [_vm._v("If you'd like to link Confluence content to your requirements, please install "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("rmCloud Connector")]), _vm._v(" on your Confluence instance.")])]), _vm._v(" "), _c('div', {
    staticClass: "mt-5"
  }, [_c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('h4', [_vm._v("Other settings")]), _vm._v(" "), _c('h5', [_vm._v("When a requirement is created or updated")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.commentOnAssociatedIssues),
      expression: "commentOnAssociatedIssues"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.commentOnAssociatedIssues) ? _vm._i(_vm.commentOnAssociatedIssues, null) > -1 : (_vm.commentOnAssociatedIssues)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.commentOnAssociatedIssues,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.commentOnAssociatedIssues = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.commentOnAssociatedIssues = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.commentOnAssociatedIssues = $$c
        }
      }
    }
  }), _vm._v("\n          Add comment to associated Jira issues\n        ")])]), _vm._v(" "), _c('h5', [_vm._v("When a requirement is assigned")]), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.sendEmailNotificationToAssignee),
      expression: "sendEmailNotificationToAssignee"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.sendEmailNotificationToAssignee) ? _vm._i(_vm.sendEmailNotificationToAssignee, null) > -1 : (_vm.sendEmailNotificationToAssignee)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.sendEmailNotificationToAssignee,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.sendEmailNotificationToAssignee = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.sendEmailNotificationToAssignee = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.sendEmailNotificationToAssignee = $$c
        }
      }
    }
  }), _vm._v("\n          Send email notification to assignee\n        ")])]), _vm._v(" "), (_vm.$auth.user().installed_on_confluence) ? _c('div', [_c('h5', [_vm._v("Confluence space(s) to show when linking to requirements")]), _vm._v(" "), _c('p', [_vm._v("Only pages from these spaces will show up when linking requirements to pages.")]), _vm._v(" "), _c('p', [_vm._v("Leave this blank if you want to show pages from all spaces.")]), _vm._v(" "), _c('p', [_vm._v("To get your space name, check the URL of one of your Confluence pages. It will be yoursite.atlassian.net/wiki/spaces/SPACENAME/...")]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-md-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.confluenceSpacesToFilter),
      expression: "confluenceSpacesToFilter"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "SPACE1,SPACE2"
    },
    domProps: {
      "value": (_vm.confluenceSpacesToFilter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.confluenceSpacesToFilter = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-text text-muted",
    attrs: {
      "id": "spacesHelpBlock"
    }
  }, [_vm._v("\n            The space names should be comma separated e.g. SPACE1,SPACE2,SPACE3\n          ")])])]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae9bd644"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/configuration/ConfigurationView.vue
// module id = 1024
// module chunks = 1